<div class="section">
  <app-card-table [config]="tableConfig" />
</div>
